import { render, staticRenderFns } from "./AlertInfo.vue?vue&type=template&id=75aeb9fd&"
import script from "./AlertInfo.vue?vue&type=script&lang=ts&"
export * from "./AlertInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AlertInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports